<template>
  <div>
    <!-- modal -->
    <b-modal
      :id="`modal-delete-${idModal}`"
      :title="title"
      cancel-title="cancelar"
      cancel-variant="outline-secondary"
      ok-variant="danger"
      ok-title="Deletar"
      centered
      @ok="$emit('okDeleteFluxoChat')"
    >
      <b-card-text>
       <slot name="content-message"></slot>
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import { BButton, BModal, VBModal } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BButton,
    BModal,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    idModal: {
      type: String,
      default: 'fluxo-chat',
    },
  },
}
</script>
